import React, { useEffect } from 'react';
import {
  useDispatch,
  useSelector
} from 'react-redux';

import {
  Link as RouterLink
} from 'react-router-dom';

import {
  Typography,
  Chip,
  makeStyles,
} from '@material-ui/core';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Hidden,
} from '@material-ui/core';

import { Loading } from '../Common';
import { getUserAssetList } from '../../store/actions';

const useStyles = makeStyles((theme) => ({
  striped: {
    backgroundColor: '#EAEAEA',
    paddingTop: '.5em',
    paddingBottom: '.5em',
    textDecoration: 'none',
    color: 'black'
  },
  unstriped: {
    backgroundColor: '#fff',
    paddingTop: '.5em',
    paddingBottom: '.5em',
    textDecoration: 'none',
    color: 'black'
  },
  content: {
    padding: theme.spacing(3),
  },
  returned: {
    color: theme.palette.text.disabled,
  },
}));

const MyDevices = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isLoading, users } = useSelector((state) => state.userAssets);

  useEffect(() => {
    dispatch(getUserAssetList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allDevices = [];
  if (users && users.length) {
    users.forEach((owner) => {
      const isReturned = owner.ownerType === 'returned';
      owner.assets.forEach((asset) => {
        allDevices.push({
          ...asset,
          ownerDisplay: owner.ownerDisplay,
          ownerType: owner.ownerType,
          isReturned,
        });
      });
    });
  }

  return (
    <div className={classes.content}>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <h2>My Devices</h2>
          {allDevices.length === 0 ? (
            <Typography variant="body1">No devices assigned.</Typography>
          ) : (
            <Table size="small" aria-label="list of my devices">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="overline">Device</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="overline">Type</Typography>
                  </TableCell>
                  <Hidden smDown>
                    <TableCell>
                      <Typography variant="overline">Condition</Typography>
                    </TableCell>
                  </Hidden>
                  <Hidden smDown>
                    <TableCell>
                      <Typography variant="overline">Status</Typography>
                    </TableCell>
                  </Hidden>
                </TableRow>
              </TableHead>
              <TableBody>
                {allDevices.map((device, index) => (
                  <TableRow
                    key={device._id || index}
                    className={(index % 2 === 0) ? classes.unstriped : classes.striped}
                    hover
                    component={RouterLink}
                    to={`/device/${device.assetType}/asset/${device._id}`}
                    style={{ textDecoration: 'none' }}
                  >
                    <TableCell>
                      <Typography
                        variant="caption"
                        className={device.isReturned ? classes.returned : ''}
                      >
                        {device.assetName}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="caption"
                        className={device.isReturned ? classes.returned : ''}
                      >
                        {device.assetType}
                      </Typography>
                    </TableCell>
                    <Hidden smDown>
                      <TableCell>
                        <Typography
                          variant="caption"
                          className={device.isReturned ? classes.returned : ''}
                        >
                          {device.assetCondition}
                        </Typography>
                      </TableCell>
                    </Hidden>
                    <Hidden smDown>
                      <TableCell>
                        {device.isReturned ? (
                          <Chip label="Returned" size="small" variant="outlined" />
                        ) : (
                          <Chip label="Active" size="small" color="primary" />
                        )}
                      </TableCell>
                    </Hidden>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </>
      )}
    </div>
  );
};

export { MyDevices };
